export type HomepageSearchMode = "purchase" | "rent-to-buy" | "sell" | "commercial";

export function resolveHomepageSearchMode(
  mode: string | null | undefined,
  tabLabel: string | null | undefined,
  index: number,
): HomepageSearchMode {
  if (mode === "purchase" || mode === "rent-to-buy" || mode === "sell" || mode === "commercial") {
    return mode;
  }

  const normalizedLabel = String(tabLabel || "").trim().toLocaleLowerCase("it");
  if (normalizedLabel.includes("rent to buy")) return "rent-to-buy";
  if (normalizedLabel.includes("vend")) return "sell";
  if (normalizedLabel.includes("commercial")) return "commercial";

  return index === 1 ? "rent-to-buy" : index === 2 ? "sell" : index === 3 ? "commercial" : "purchase";
}
